/* tslint:disable */
/* eslint-disable */
/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
/**
 * TeamInvitesApi - axios parameter creator
 */
export const TeamInvitesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} teamId 
         * @param {string} [email] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdTeamInvitesAcceptGet: async (teamId: string, email?: string, token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdTeamInvitesAcceptGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/TeamInvites/accept`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdTeamInvitesGet: async (teamId: string, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdTeamInvitesGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/TeamInvites`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {string} inviteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdTeamInvitesInviteIdDelete: async (teamId: string, inviteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdTeamInvitesInviteIdDelete', 'teamId', teamId)
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('apiTeamsTeamIdTeamInvitesInviteIdDelete', 'inviteId', inviteId)
            const localVarPath = `/api/teams/{teamId}/TeamInvites/{inviteId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"inviteId"}}`, encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdTeamInvitesPost: async (teamId: string, body?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdTeamInvitesPost', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/TeamInvites`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamInvitesApi - functional programming interface
 */
export const TeamInvitesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamInvitesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} teamId 
         * @param {string} [email] 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdTeamInvitesAcceptGet(teamId: string, email?: string, token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdTeamInvitesAcceptGet(teamId, email, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamInvitesApi.apiTeamsTeamIdTeamInvitesAcceptGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdTeamInvitesGet(teamId: string, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdTeamInvitesGet(teamId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamInvitesApi.apiTeamsTeamIdTeamInvitesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {string} inviteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdTeamInvitesInviteIdDelete(teamId: string, inviteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdTeamInvitesInviteIdDelete(teamId, inviteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamInvitesApi.apiTeamsTeamIdTeamInvitesInviteIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdTeamInvitesPost(teamId: string, body?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdTeamInvitesPost(teamId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamInvitesApi.apiTeamsTeamIdTeamInvitesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamInvitesApi - factory interface
 */
export const TeamInvitesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamInvitesApiFp(configuration)
    return {
        /**
         * 
         * @param {TeamInvitesApiApiTeamsTeamIdTeamInvitesAcceptGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdTeamInvitesAcceptGet(requestParameters: TeamInvitesApiApiTeamsTeamIdTeamInvitesAcceptGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdTeamInvitesAcceptGet(requestParameters.teamId, requestParameters.email, requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeamInvitesApiApiTeamsTeamIdTeamInvitesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdTeamInvitesGet(requestParameters: TeamInvitesApiApiTeamsTeamIdTeamInvitesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdTeamInvitesGet(requestParameters.teamId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeamInvitesApiApiTeamsTeamIdTeamInvitesInviteIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdTeamInvitesInviteIdDelete(requestParameters: TeamInvitesApiApiTeamsTeamIdTeamInvitesInviteIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdTeamInvitesInviteIdDelete(requestParameters.teamId, requestParameters.inviteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeamInvitesApiApiTeamsTeamIdTeamInvitesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdTeamInvitesPost(requestParameters: TeamInvitesApiApiTeamsTeamIdTeamInvitesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdTeamInvitesPost(requestParameters.teamId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiTeamsTeamIdTeamInvitesAcceptGet operation in TeamInvitesApi.
 */
export interface TeamInvitesApiApiTeamsTeamIdTeamInvitesAcceptGetRequest {
    readonly teamId: string

    readonly email?: string

    readonly token?: string
}

/**
 * Request parameters for apiTeamsTeamIdTeamInvitesGet operation in TeamInvitesApi.
 */
export interface TeamInvitesApiApiTeamsTeamIdTeamInvitesGetRequest {
    readonly teamId: string

    readonly userId?: string
}

/**
 * Request parameters for apiTeamsTeamIdTeamInvitesInviteIdDelete operation in TeamInvitesApi.
 */
export interface TeamInvitesApiApiTeamsTeamIdTeamInvitesInviteIdDeleteRequest {
    readonly teamId: string

    readonly inviteId: string
}

/**
 * Request parameters for apiTeamsTeamIdTeamInvitesPost operation in TeamInvitesApi.
 */
export interface TeamInvitesApiApiTeamsTeamIdTeamInvitesPostRequest {
    readonly teamId: string

    readonly body?: string
}

/**
 * TeamInvitesApi - object-oriented interface
 */
export class TeamInvitesApi extends BaseAPI {
    /**
     * 
     * @param {TeamInvitesApiApiTeamsTeamIdTeamInvitesAcceptGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdTeamInvitesAcceptGet(requestParameters: TeamInvitesApiApiTeamsTeamIdTeamInvitesAcceptGetRequest, options?: RawAxiosRequestConfig) {
        return TeamInvitesApiFp(this.configuration).apiTeamsTeamIdTeamInvitesAcceptGet(requestParameters.teamId, requestParameters.email, requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeamInvitesApiApiTeamsTeamIdTeamInvitesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdTeamInvitesGet(requestParameters: TeamInvitesApiApiTeamsTeamIdTeamInvitesGetRequest, options?: RawAxiosRequestConfig) {
        return TeamInvitesApiFp(this.configuration).apiTeamsTeamIdTeamInvitesGet(requestParameters.teamId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeamInvitesApiApiTeamsTeamIdTeamInvitesInviteIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdTeamInvitesInviteIdDelete(requestParameters: TeamInvitesApiApiTeamsTeamIdTeamInvitesInviteIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TeamInvitesApiFp(this.configuration).apiTeamsTeamIdTeamInvitesInviteIdDelete(requestParameters.teamId, requestParameters.inviteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeamInvitesApiApiTeamsTeamIdTeamInvitesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdTeamInvitesPost(requestParameters: TeamInvitesApiApiTeamsTeamIdTeamInvitesPostRequest, options?: RawAxiosRequestConfig) {
        return TeamInvitesApiFp(this.configuration).apiTeamsTeamIdTeamInvitesPost(requestParameters.teamId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}

